import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, ListItem, MenuItem, Paper, TextField, Typography } from "@mui/material"
import { TableContainer, TableBody, Table, TableHead, TableRow, TableCell } from "@mui/material"
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Restaurant, MenuBook, Edit, Delete, Close as CloseIcon } from "@mui/icons-material";
import { Container } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Collapse from '@mui/material/Collapse';
import { AddMenuForm } from "../../Forms/AddMenuform";
import { WarningDialog } from "../../modal/WarningDialog";

import { addMenu, addMenuBulk, deleteCategory, deleteItem, editCatgCall, editItemCall, getlistMenu } from "../../hooks/apiHandler";
import { useAuth } from "../../hooks/useAuth";


export const MenuPage = () => {

  var [listMenu, setMenuList] = useState([]);
  const { Logout } = useAuth();
  var storeID = useRef(JSON.parse(window.localStorage.getItem('ds')));

  const [showModal, setshowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState({
    popupModel: false,
    catID: '',
    editName: ''
  });
  const [editItem, setEditItem] = useState();
  const [isDialogOpen, setDialogOpen] = useState({ model: false, id: null });


  useEffect(() => {
    // start Loading Icon or Bar.
    async function calldeviceList() {
      var response = await getlistMenu({ storeID: storeID.current }, Logout);
      setMenuList(await response.data);
      console.log(response.data);
    }

    calldeviceList()
    return () => {
      // this is same as component unmount of leaving the page..
    }
  }, [Logout]);

  const [openIndex, setOpenIndex] = useState(null);
  const handleDropDown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const handleRemoveItem = async (productID) => {
    console.log(productID);
    var response = await deleteItem({ storeID: storeID.current, itemID: productID }, Logout);
    console.log(response);
    setMenuList(await response.data);
  }
  const handleRemoveCatg = async (catgoryID) => {
    console.log(catgoryID);
    setDialogOpen({ model: true, id: catgoryID });
  }
  const handleConfirm = async () => {
    console.log("Confirmed action");
    var response = await deleteCategory({ storeID: storeID.current, catgID: isDialogOpen.id }, Logout);
    console.log(response);
    setMenuList(await response.data);
    setDialogOpen({ model: false, id: null });
  };

  const handleEditItem = async (productID, currentCatgory) => {
    console.log(productID, currentCatgory);
    setEditItem({ ...productID, currentCatgory });
    setshowModal(true);
  }
  const handleEditCatg = async (productID, name) => {
    console.log(productID);
    console.log(name);
    setShowEditModal({
      popupModel: true,
      catID: productID,
      editName: name
    });
  }

  const handleModelClose = () => {
    setshowModal((prev) => !prev);
    // calldeviceList(); // this is called on model Close..
    setEditItem();
  };

  // dropdown Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl); // Derived state for open status

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Csv to Json method 
  const [jsonData, setJsonData] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];

    if (!file || !(file instanceof Blob)) {
      console.error('Invalid file:', file);
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const text = event.target.result;
      const json = csvToJson(text);
      setJsonData(json);
    };

    reader.readAsText(file);
  };

  const csvToJson = (csv) => {
    const [headerLine, ...lines] = csv.trim().split('\n');
    const headers = headerLine.split(',').map(h => h.trim());

    return lines.map((line) => {
      const values = line.split(',').map(v => v.trim());
      const obj = {};
      headers.forEach((header, i) => {
        obj[header] = values[i] ?? '';
      });
      return obj;
    });
  };

  // eslint-disable-next-line
  const sendToApi = async (csvRows) => {
    try {
      // Map CSV headers to match API format
      const menuItems = csvRows.map(row => ({
        category: row.category || row.Category,  // case-insensitive mapping
        item: row.item || row.Item,
        price: parseFloat(row.price || row.Price) || 0,
        description: row.description || row.Description || "",
        available: row.available !== undefined ? row.available === "true" || row.available === true : true,
        inStore: row.inStore !== undefined ? row.inStore === "true" || row.inStore === true : true,
        online: row.online !== undefined ? row.online === "true" || row.online === true : true,
        restaurantPatner: row.restaurantPatner !== undefined ? row.restaurantPatner === "true" || row.restaurantPatner === true : false,
      }));

      const payload = {
        storeID: storeID.current,
        menuItems: menuItems
      };

      const response = await addMenuBulk(payload, Logout);

      if (response.code === 0) {
        console.log("Bulk upload successful:", response.data);
        setMenuList(response.data);
        setJsonData([]);
      } else {
        console.error("Bulk upload failed:", response);
      }
    } catch (error) {
      console.error(" Error in sendToApi:", error);
    }
  };



  return (
    <Container>


      <Box sx={{ display: "flex", justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <Box>
          <Chip sx={{ m: '10px' }} label={`Total Category: ${listMenu.length}`} onClick={() => { }} />
          <Chip sx={{ m: '10px' }} label={`Number of Items: ${listMenu.reduce((sum, category) => sum + category.items.length, 0)}`} variant="outlined" onClick={() => { }} />
        </Box>
        <Box>
          <Button sx={{ m: '10px' }} variant="outlined" onClick={() => {
            setshowModal((prev) => !prev);
          }}>+Add Menu</Button>
          <IconButton
            aria-label="more"
            aria-controls={open ? "csv-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="csv-menu" anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem>
              <label htmlFor="upload-csv" style={{ width: "100%", cursor: "pointer" }}>
                <ListItemText primary="Upload CSV" />
              </label>
              <input
                id="upload-csv"
                type="file"
                accept=".csv"
                hidden
                onChange={handleFileUpload}
              />
            </MenuItem>
            <MenuItem component="a" href="/menu_items.csv" download onClick={handleClose}>
              <ListItemText primary="Download Menu CSV" />
            </MenuItem>
          </Menu>
        </Box>
      </Box>


      {
        jsonData.length === 0 ? (
          <></>
        ) : (
          <>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* Dynamically render headers */}
                    {Object.keys(jsonData[0]).map((key, index) => (
                      <TableCell key={index} sx={{ fontWeight: "bold" }}>
                        {key}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {jsonData.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Object.values(row).map((val, colIndex) => (
                        <TableCell key={colIndex}>{val}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setJsonData([])} // Reset jsonData
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => sendToApi(jsonData)}
              >
                Save
              </Button>
            </Box>
          </>
        )
      }


      <Box sx={{ p: 2 }}></Box>
      {/* End of extra Admin Panel */}

      <List>
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
          {listMenu.length > 0 ? (
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {listMenu.map((item, pindex) => (
                <React.Fragment key={`cat-${pindex}`}>
                  {/* 📌 Category List Item */}
                  <ListItem
                    sx={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: 2,
                      mb: 1,
                      transition: "0.3s",
                      "&:hover": { backgroundColor: "#e0e0e0" },
                    }}
                  >
                    <ListItemButton onClick={() => handleDropDown(pindex)}>
                      <ListItemIcon>
                        <MenuBook sx={{ color: "#3f51b5" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="h6" fontWeight="bold">
                            {item.catgory}
                          </Typography>
                        }
                      />
                      <Chip
                        size="small"
                        label={`Items: ${item.items.length}`}
                        sx={{ borderColor: "#3f51b5", color: "#3f51b5" }}
                        variant="outlined"
                      />
                      {openIndex === pindex ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                  </ListItem>

                  {/* 📌 Collapsible Section for Items */}
                  <Collapse in={openIndex === pindex} timeout="auto" unmountOnExit>
                    <Box sx={{ pl: 4, pb: 1 }}>
                      {/* 📌 Category Edit & Delete Actions */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#eeeeee",
                          p: 1,
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          Edit Category: {item.catgory}
                        </Typography>
                        <Box>
                          <IconButton color="warning" size="small"
                            onClick={() => handleEditCatg(item._id, item.catgory)}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton color="error" size="small"
                            onClick={() => handleRemoveCatg(item._id)}
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      {/* 📌 Nested Items List */}
                      <List disablePadding>
                        {item.items.map((nestedItem, index) => (
                          <ListItem
                            key={`item-${pindex}-${index}`}
                            sx={{
                              pl: 2,
                              borderRadius: 1,
                              mb: 1,
                              transition: "0.3s",
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            <ListItemIcon>
                              <Restaurant sx={{ color: "#43a047" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="subtitle1">
                                  {nestedItem.item}
                                </Typography>
                              }
                              secondary={`Price: $${nestedItem.price}`}
                            />
                            {/* 📌 Item Actions */}
                            <Box>
                              <IconButton color="warning" size="small"
                                onClick={() => handleEditItem(nestedItem, item.catgory)}
                              >
                                <Edit />
                              </IconButton>
                              <IconButton color="error" size="small"
                                onClick={() => handleRemoveItem(nestedItem._id)}
                              >
                                <Delete />
                              </IconButton>
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </Collapse>

                </React.Fragment>
              ))}
            </List>
          ) : (
            <Typography variant="body1" textAlign="center" color="textSecondary">
              No Data Found For Display.
            </Typography>
          )}
        </Paper>
      </List>

      <Dialog
        open={showModal}
        onClose={handleModelClose}
        maxWidth="md"
        fullWidth
        // Ensure the dialog body itself can scroll if the content is tall
        scroll="paper"
        sx={{ '& .MuiDialog-paper': { minHeight: 400, maxHeight: '90vh' } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {editItem ? 'Edit Menu Item' : 'Add New Menu Item'}
          <IconButton
            onClick={handleModelClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>

          <AddMenuForm
            itemInfo={editItem || {}} // Pass empty object if adding, or item data if editing
            onsave={async (formData, currentCatgory) => {
              const isEditing = Boolean(editItem);
              const apiCall = isEditing ? editItemCall : addMenu;
              let newData = { ...formData };

              if (isEditing) {
                // If the category is not '000', update 'newCatgory' and assign the correct category value
                if (formData.catgory !== '000') {
                  newData.newCatgory = formData.catgory;
                  newData.catgory = currentCatgory;
                } else {
                  // Handle new category input case, where a custom category is added
                  newData.newCatgory = formData.newCatgory;
                  newData.catgory = currentCatgory; // Representing the new custom category
                }
              }
              
              console.log("Form Data:", formData);
              try {
                const response = await apiCall(newData, Logout);
                console.log(response);
                if (response.code === 0) {
                  setMenuList(response.data);
                } else {
                  console.log('Failed to add menu item. Please try again.');
                }
              } catch (error) {
                console.error('Error occurred while adding menu:', error);
              }

              handleModelClose();
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleModelClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {/* 
      <EditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        category={selectedCategory}
        item={selectedItem}
        onSave={handleSave}
      /> */}

      <Dialog open={showEditModal.popupModel} onClose={() => setShowEditModal({
        popupModel: false,
        catID: '',
        editName: ''
      })}>
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
            <TextField
              variant="filled"
              id="storename"
              value={showEditModal.editName}  // Ensure storeInfo is defined
              type="text"
              placeholder="Enter category name"
              required
              size="small"
              onChange={(e) => { setShowEditModal({ ...showEditModal, editName: e.target.value }) }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEditModal({
            popupModel: false,
            catID: '',
            editName: ''
          })}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                var response = await editCatgCall({ storeID: storeID.current, id: showEditModal.catID, editName: showEditModal.editName }, Logout);
                if (await response.code === 0) {
                  setMenuList(response.data);
                } else {
                  console.log(response);
                }
                setShowEditModal({
                  popupModel: false,
                  catID: '',
                  editName: ''
                })
              } catch (error) {
                console.error("Error updating category:", error);
              }
            }}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <WarningDialog
        isOpen={isDialogOpen.model}
        onClose={() => setDialogOpen({ model: false, id: null })}
        onConfirm={handleConfirm}
        title="Warning!"
        message={<span>Are you sure you want to proceed? <br /><br /> All Items in the Catgory Will be Remove...</span>}
      />

    </Container >
  );
};
